import { render, staticRenderFns } from "./FileUploadBox.vue?vue&type=template&id=541a9737&scoped=true&"
import script from "./FileUploadBox.vue?vue&type=script&lang=ts&"
export * from "./FileUploadBox.vue?vue&type=script&lang=ts&"
import style0 from "./FileUploadBox.vue?vue&type=style&index=0&id=541a9737&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541a9737",
  null
  
)

export default component.exports